
import { mapGetters, mapState, mapMutations } from "vuex";
import ReportOrderFilterOptions from "./report-order-filter-options.vue";

export default {
  components: {
    ReportOrderFilterOptions
  },
  props: {
    payments: {
      type: Array,
      default: () => []
    },
    stages: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    menu: false
  }),

  computed: {
    ...mapState("report", ["orderFilterCount"])
  },
  methods: {
    handleFetchReport() {
      this.$emit("fetchReport");
    }
  }
};
